import { render, staticRenderFns } from "./InsurerConsumables.vue?vue&type=template&id=446e0709"
import script from "./InsurerConsumables.vue?vue&type=script&lang=js"
export * from "./InsurerConsumables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('446e0709')) {
      api.createRecord('446e0709', component.options)
    } else {
      api.reload('446e0709', component.options)
    }
    module.hot.accept("./InsurerConsumables.vue?vue&type=template&id=446e0709", function () {
      api.rerender('446e0709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerConsumables.vue"
export default component.exports